import { render, staticRenderFns } from "./LessonCreate.vue?vue&type=template&id=347d9af8&scoped=true&"
import script from "./LessonCreate.vue?vue&type=script&lang=js&"
export * from "./LessonCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d9af8",
  null
  
)

export default component.exports